import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import classNames from 'classnames';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { fireCustomDimension } from '../../../utils/common';

class ElementInView extends React.Component {
  constructor() {
    super();
    this.ref = React.createRef();
  }

  componentDidMount() {
    if (this.props.enableViewGA) {
      this.throttledGAonScroll = throttle(this.handleGAOnScroll, 100);
      window.addEventListener('scroll', this.throttledGAonScroll);
    }
  }

  componentWillUnmount() {
    this.removeScrollEvent();
  }

  removeScrollEvent = () => {
    window.removeEventListener('scroll', this.throttledGAonScroll);
  };

  isElementEdgesVisible = (el, skewFromTop) => {
    if (el) {
      const rect = el.getBoundingClientRect();
      const { top, bottom } = rect;
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

      if (skewFromTop) {
        return top <= windowHeight;
      }
      return bottom <= 0;
    }
    return false;
  };

  handleGAOnScroll = () => {
    const {
      gaCategory,
      gaAction,
      gaLabel,
      customDimensions,
      skewFromTop,
      onGAFired,
      fireGA,
    } = this.props;
    const prevTop = 0;
    let currentTop = 0;
    const doc = document.documentElement;
    currentTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    const gaCat = gaCategory || window.categoryForGA;
    const gaAct = gaAction || 'scroll';
    const gaLab = gaLabel === 'wu' ? window?.location?.href : gaLabel || 'view';

    if (currentTop > prevTop) {
      if (customDimensions && customDimensions.constructor.name === 'Object') {
        const Dimensions = Object.keys(customDimensions);
        Dimensions.forEach(dimension => {
          fireCustomDimension(customDimensions[dimension], dimension);
        });
      }
      if (
        this.ref &&
        this.ref.current &&
        this.isElementEdgesVisible(this.ref.current, skewFromTop)
      ) {
        // This is done to WEB-articleshowv2 | scroll and mWEB-articleshowv2 GA TOIPR-70372
        if (gaCat === 'WEB-articleshowv2' && gaAct === 'scroll') {
          return;
        }
        if (
          gaCat === 'mWEB-articleshowv2' &&
          gaAct === 'scroll' &&
          gaLabel !== 'readAlso_view'
        ) {
          return;
        }
        // if (gaCat === 'mWEB-articleshowv2' && gaAct === 'View') {
        //   return;
        // }
        if (gaCat === 'liveblog_new_web' && gaAct === 'scroll') {
          return;
        }
        if (gaCat === 'liveblog_new_mweb' && gaAct === 'scroll') {
          return;
        }
        if (gaCat === 'liveblog_new_web' && gaAct === 'NavBar-Header') {
          return;
        }
        if (fireGA) {
          analyticsWrapper('gaAndGrx', 'send', 'event', gaCat, gaAct, gaLab, {
            nonInteraction: 1,
          });
        }

        if (onGAFired && typeof onGAFired === 'function') {
          onGAFired();
        }

        this.removeScrollEvent();
      }
    }
  };

  render() {
    const { className } = this.props;
    const containerClass = classNames({
      [className]: !!className,
    });
    return (
      <div ref={this.ref} className={containerClass}>
        {this.props.children}
      </div>
    );
  }
}

ElementInView.propTypes = {
  enableViewGA: PropTypes.bool,
  gaAction: PropTypes.string,
  gaLabel: PropTypes.string,
  gaCategory: PropTypes.string,
  children: PropTypes.node.isRequired,
  skewFromTop: PropTypes.bool,
  className: PropTypes.string,
  onGAFired: PropTypes.func,
  fireGA: PropTypes.bool,
};

ElementInView.defaultProps = {
  gaAction: '',
  gaLabel: '',
  gaCategory: '',
  enableViewGA: true,
  skewFromTop: true,
  className: '',
  onGAFired: () => {},
  fireGA: true,
};

export default ElementInView;
